/*
  肥後屋 卸・法人販売ページのお問い合わせフォーム（HIGOYA-55 / 谷口様2026-09-03指示）

  必須項目が空のまま送信されないようにし、「お問い合わせ」ページ
  （assets/lp-contact-form.js）と同じ赤字のエラーを項目の下に出す。
  あちらは入力→確認の2ステップだが、卸フォームは1ステップなので送信時に
  検証する。required 属性は残してあるので、JSが読み込まれなかった場合でも
  ブラウザ既定の検証で送信は止まる。
*/
class LpWholesaleContactForm extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    if (!this.form) return;

    // ブラウザ既定の吹き出しは出さず、こちらのエラー表示に一本化する。
    this.form.setAttribute('novalidate', 'novalidate');
    this.form.addEventListener('submit', this.onSubmit.bind(this));

    // 一度エラーを出した項目は、入力・選択された時点で赤字を消す
    // （直したのに赤いままだと、直っていないように見えるため）。
    this.form.addEventListener('input', this.clearIfValid.bind(this));
    this.form.addEventListener('change', this.clearIfValid.bind(this));
  }

  clearIfValid(event) {
    const field = event.target;
    if (!field.hasAttribute('required') || !field.checkValidity()) return;
    field.classList.remove('lp-wh-field__input--error');
    const errorEl = this.form.querySelector(`[data-error-for="${field.id}"]`);
    if (errorEl) errorEl.hidden = true;
  }

  onSubmit(event) {
    const fields = this.form.querySelectorAll('[required]');
    let firstInvalid = null;

    fields.forEach((field) => {
      const errorEl = this.form.querySelector(`[data-error-for="${field.id}"]`);
      const valid = field.checkValidity();
      field.classList.toggle('lp-wh-field__input--error', !valid);
      if (errorEl) errorEl.hidden = valid;
      if (!valid && !firstInvalid) firstInvalid = field;
    });

    if (firstInvalid) {
      event.preventDefault();
      firstInvalid.focus();
      firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }
}

customElements.define('lp-wh-contact-form', LpWholesaleContactForm);
